// utils/secureStorage.ts
const tokenKey = "X-Access-Token";

export const getToken = () => {
  const token = localStorage.getItem(tokenKey);
  if (!token) return null;
  try {
    return token;
  } catch {
    return token;
  }
};

export const setToken = (token: string) => {
  localStorage.setItem(tokenKey, token);
};

export const removeToken = () => {
  localStorage.removeItem(tokenKey);
};
